import { SimilarProgram } from "./similar-program";

export class ResponseMessage {
    public success: boolean;
    public message: string;
    public id: number;
    public similarPrograms: SimilarProgram[];
    public importValidationErrors: ImportValidationError[];
}

export class ImportValidationError {
    public rowNumber: number;
    public column: string;
    public errorMessage: string;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/common/response-message.ts